<script type="text/javascript">
	import { get, writable } from "svelte/store";
	import { onMount, afterUpdate, beforeUpdate, tick } from "svelte";

	import LoadState from "../../../Enums/LoadState";

	import ModalWindow from "../../ModalWindow.svelte"
	import UserPreferencesStore from "./Store"

	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Tab, { Icon, Label } from '@smui/tab';
  	import TabBar from '@smui/tab-bar';
	import IconButton from "@smui/icon-button";
	import Button, {Label as ButtonLabel} from '@smui/button';

  	import Form from '../../Admin/Form.svelte';
	import CMSSpinner from "../../Admin/CMSSpinner.svelte";
	import SpinnerButton from "../../Admin/SpinnerButton.svelte";

	import MenuItem from "../../FlyoutMenu/MenuItem.svelte"
	import MenuItemTitle from "../../FlyoutMenu/MenuItemTitle.svelte"
	import NavPath from '../../NavPath/NavPath.svelte';
	import NavPathItem from '../../NavPath/Item.svelte';

	import User from "../../../Branding/User";
	import Feature from "../../../Branding/Feature";

	import DateDialect from "../../../Enums/DateDialect";
	import LngLatFormat from "../../../Enums/LngLatFormat";

	let modal;
	let generalForm;

	let currentUser = UserPreferencesStore.dashboard.data.currentUser;
	let visible = UserPreferencesStore.dashboard.meta.visible;
	let initState = UserPreferencesStore.dashboard.meta.initState;
	let loadState = UserPreferencesStore.dashboard.meta.loadState;

	$: {
		if ($visible) {
			UserPreferencesStore.dashboard.actions.init();
		}
	};
	$: if (generalForm) generalForm.setReadOnly(false);

	let tabs = ["General"]
	let activeTab = writable("General");

	let thisDateDialect = null;
	let thisLngLatFormat = null;
	let thisBathymetryEnabled = null;
	let thisMapViewType = null;
	let thisMapViewOpacity = null;
	$: {
		if ($currentUser && thisDateDialect === null && thisLngLatFormat === null) {
			onReset();
		}
	}

	let onReset = () => {
		thisDateDialect = $currentUser.userDateDialect;
		thisLngLatFormat = $currentUser.userLngLatFormat;
		thisBathymetryEnabled = $currentUser.userBathymetryEnabled;
		thisMapViewType = $currentUser.userMapViewType;
		thisMapViewOpacity = $currentUser.userSatelliteViewOpacity;
	};
	let onSubmit = () => {
		UserPreferencesStore.dashboard.actions.savePreferences(thisLngLatFormat, thisBathymetryEnabled, thisMapViewType, thisMapViewOpacity)
			.then(()=>{
				generalForm.snackbar.start("Preferences saved successfully.", "success");
			})
			.catch((err)=>{
				generalForm.snackbar.start("Preferences save failed.", "error");
			})
	};


</script>

<ModalWindow
	materialIcon={"account_circle"}
	title={`User Preferences`}
	hasCloseButton={true}
	resizable={false}
	draggable={false}
	fullscreen={true}
	padding={false}
	bind:open={$visible}
	bind:this={modal} >

	{#if $initState === LoadState.LOADING}

		<CMSSpinner/>

	{:else if $initState === LoadState.LOADED}

		<TabBar tabs={tabs} let:tab bind:active={$activeTab} class="border-shadow">
			<Tab {tab} minWidth><Label>{tab}</Label></Tab>
		</TabBar>
		<div class='tab-content'>

			{#if $activeTab == "General"}

				<Form bind:this={generalForm} id='company-form'>
					<MenuItemTitle title={"General Preferences"} materialIcon={"info"}/>

					<DataTable table$aria-label="General Preferences">
						<Head>
							<Row>
								<Cell></Cell>
								<Cell></Cell>
							</Row>
						</Head>
						<Body>
							<!--
							Deprecated this!
							<Row>
								<Cell style="width:20%;">Date Dialect</Cell>
								<Cell>
									<select class='default' bind:value={thisDateDialect}>
										{#each Object.keys(DateDialect) as dialectKey}
											<option value={DateDialect[dialectKey]} selected={thisDateDialect === DateDialect[dialectKey]}>
												{#if DateDialect[dialectKey] === DateDialect.NULL}
													Use Geonius Default
												{:else}
													{dialectKey}
												{/if}
											</option>
										{/each}
									</select>
								</Cell>
							</Row> -->
							<Row>
								<Cell>LngLat Format</Cell>
								<Cell>
									<select class='default' bind:value={thisLngLatFormat}>
										{#each Object.keys(LngLatFormat) as formatKey}
											<option value={LngLatFormat[formatKey]} selected={thisLngLatFormat === LngLatFormat[formatKey]}>
												{#if LngLatFormat[formatKey] === LngLatFormat.NULL}
													Use Geonius Default
												{:else}
													{formatKey}
												{/if}
											</option>
										{/each}
									</select>
								</Cell>
							</Row>
						</Body>
					</DataTable>

					{#if $loadState == LoadState.LOADING}
						<SpinnerButton/>
					{:else}
						<Button on:click={onSubmit} color="primary" variant="unelevated"><ButtonLabel>Save</ButtonLabel></Button>
					{/if}

					<Button on:click={onReset} color="primary" class="bg-info" variant="unelevated"><ButtonLabel>Reset</ButtonLabel></Button>

				</Form>

			{/if}

		</div>
	{/if}
</ModalWindow>

